import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Row, Table } from 'antd';
import {
  queryGlobalConfigInfo,
  queryGlobalConfigList,
  querySaveGlobalConfig,
} from '@api/core/config';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import moment from 'moment';

import ModalGlobalConfigAdd from './ModalGlobalConfigAdd';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      total: 0,
      pageNo: 1,
      isPermission: false,
      visible: false,
      dataInfo: null,
    };
  }

  componentDidMount() {
    this.loadData(1);
    this.judge(this.props.account_info);
  }

  componentWillUnmount() {
    const { pageNo, condition } = this.state;
    const params = {
      pageNo,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  // 加载需公司账户信息数据
  loadData = pageNo => {
    const params = {};
    const { condition } = this.state;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryGlobalConfigList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { pageNo } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData(pageNo);
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = accountInfo => {
    let isPermission = false;
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState({
      isPermission,
    });
  };

  columns = () => {
    return [
      {
        title: '配置项标题',
        dataIndex: 'label',
      },
      {
        title: '配置项值',
        dataIndex: 'value',
      },
      {
        title: '配置项描述',
        dataIndex: 'desc',
      },
      {
        title: '创建时间',
        dataIndex: 'createDate',
        render: text => <span>{moment.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss')}</span>,
      },
      {
        title: '更新时间',
        dataIndex: 'updateDate',
        render: text => <span>{moment.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss')}</span>,
      },
      {
        title: '操作',
        render: (text, record) => {
          const { isPermission } = this.state;
          return (
            <span>
              {isPermission ? <a onClick={() => this.editGlobalConfig(record.uuid)}>编辑</a> : null}
            </span>
          );
        },
      },
    ];
  };

  handlerVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  addGlobalConfig = () => {
    this.handlerVisible(true);
    this.setState({ dataInfo: null });
  };

  editGlobalConfig = uuid => {
    queryGlobalConfigInfo({
      uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState(
          {
            dataInfo: res.data,
          },
          () => this.handlerVisible(true),
        );
      } else {
        message.error(res.message);
      }
    });
  };

  saveGlobalConfig = item => {
    querySaveGlobalConfig(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data, isLoading, total, pageNo, isPermission, visible, dataInfo } = this.state;

    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Card>
          <div className="tableList">
            <Row style={{ paddingBottom: '20px' }}>
              <Col span={13}>
                {isPermission ? (
                  <Button type="primary" onClick={this.addGlobalConfig}>
                    添加
                  </Button>
                ) : null}
              </Col>
              <Col span={11}>
                <div className="tableListForm">{this.renderSearchForm()}</div>
              </Col>
            </Row>
          </div>
          <Table
            rowKey="uuid"
            loading={isLoading}
            columns={this.columns()}
            dataSource={data}
            pagination={pagination}
          />
          <ModalGlobalConfigAdd
            visible={visible}
            data={dataInfo}
            onOk={params => this.saveGlobalConfig(params)}
            onCancel={() => this.handlerVisible(false)}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/boss/config/Index.js